var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgButtonSignYellow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 14,
    viewBox: "0 0 15 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.06073 4.50471L6 2L7.26668 4.76367C7.66604 5.635 8.365 6.33396 9.23632 6.73331L12 8L9.49529 8.93927C8.46768 9.32462 7.64354 10.1153 7.21591 11.126L6 14L5.09267 11.3788C4.6914 10.2196 3.7804 9.3086 2.62117 8.90733L0 8L2.87398 6.78409C3.88473 6.35646 4.67538 5.53232 5.06073 4.50471Z",
    fill: "#FF9E0E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5304 1.25236L12 0L12.6333 1.38184C12.833 1.8175 13.1825 2.16698 13.6182 2.36666L15 3L13.7476 3.46963C13.2338 3.66231 12.8218 4.05764 12.608 4.56301L12 6L11.5463 4.68941C11.3457 4.1098 10.8902 3.6543 10.3106 3.45366L9 3L10.437 2.39204C10.9424 2.17823 11.3377 1.76616 11.5304 1.25236Z",
    fill: "#FF9E0E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgButtonSignYellow);
export default __webpack_public_path__ + "static/media/button_sign_yellow.ec417e155d037917c08219696f234d96.svg";
export { ForwardRef as ReactComponent };